var map = {
	"./Download@1x.png": "2c68",
	"./Download@2x.png": "cbcb",
	"./Materials@1x.png": "6d93",
	"./Materials@2x.png": "d52c",
	"./Science@1x.png": "eacc",
	"./Science@2x.png": "b87f",
	"./Students@1x.png": "436cc",
	"./Students@2x.png": "6e0d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";